<template>
  <v-dialog v-model="showModal" fullscreen persistent>
    <v-overlay :value="overlay">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card flat>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title style="font-size: 12pt">Wizyty - statusy sms</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-text>
                  <v-radio-group mandatory row v-model="typ_filtra">
                    <v-radio
                        label="Wszystkie"
                        value="0"
                    ></v-radio>
                    <v-radio
                        label="Nie wysłane"
                        value="1"
                    ></v-radio>
                    <v-radio
                        label="Do wyjaśnienia"
                        value="2"
                    ></v-radio>
                  </v-radio-group>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-data-table hide-default-footer :headers="headers"
                            :no-data-text="'Brak danych'"
                            :items="filtered_visits"
                            disable-pagination
                            class="elevation-1">
                <template v-slot:item="props">
                  <tr>
                    <td>{{getFormattedDate(props.item.startTime)}}</td>
                    <td>{{getFormattedTime(props.item)}}</td>
                    <td>{{props.item.clientName}}</td>
                    <td>{{props.item.therapistName}}</td>
                    <td>{{getStatusDescription(props.item.status)}}</td>
                    <td>{{props.item.wyslanoSMS == true ? 'TAK' : 'NIE'}}</td>
                    <td>{{props.item.numerDoSMS == true ? 'TAK' : 'NIE'}}</td>
                    <td><v-icon small class="mr-2" @click="showEditPopup(props.item.visitId)" v-if="$can('do','POKO_Wizyty_Edycja')" title="Edytuj wizyte">fa-user-edit</v-icon></td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <VisitEditor v-if="showVisitEditor" :visible="showVisitEditor" :visitData="visitData" @close="showVisitEditor = false" :zabiegi="fullZabiegiList" :typywizyt="typywizyt"></VisitEditor>
  </v-dialog>
</template>

<script>
import i18next from "i18next";
import {visitService, zabiegiService, therapistsService} from "@/services";
import swal from "sweetalert";
import * as dayjs from "dayjs";
import VisitEditor from "@/components/visits/VisitEditor";
import {mapState} from "vuex";


export default {
  name: "SearchSMSVisits",
  components: {VisitEditor},
  props: ["visible"],
  data() {
    return {
      headers: [
        {text: 'Data wizyty',  align: 'left', value: 'startTime'},
        {text: 'Godziny', align: 'left', value:'endTime'},
        {text: 'Klient',  align: 'left', value: 'clientName'},
        {text: 'Terapeuta', align: 'left', value: 'therapistName'},
        {text: 'Status', align: 'left', value: 'status'},
        {text: 'Wyslano SMS?', align: 'left',value: 'wyslanoSMS'},
        {text: 'Telefon do SMS', align: 'left', value: 'numerDoSMS'},
        {text: 'Akcje', align: 'left', value: 'id'},
      ],
      visits:[],
      typ_filtra: null,
      showVisitEditor: false,
      visitData: null,
      fullZabiegiList: [],
      typywizyt: [],
      overlay: false
    }
  },
  mounted() {
    this.headers[2].text = i18next.t('FE_KLIENT')
    this.headers[3].text = i18next.t('FE_PRACOWNIK')
    this.getAllZabiegi()
    this.getAllTypyWizyt()
    this.loadVisits()
  },
  methods: {
    showEditPopup(id) {
      this.visitData = { Id: id }
      this.showVisitEditor = true;
    },
    getAllZabiegi() {
      if(this.isFizykoTerapiaEnabled) {
        zabiegiService
            .getZabiegiList()
            .then(response => {
              if (
                  response.data != null &&
                  response.data.result != null
              ) {
                this.fullZabiegiList = response.data.result
              } else {
                throw "error pobierania terapeutów";
              }
            })
            .catch(e => {
              console.log(e)
              this.isLoadingTherapists = false;
              this.error("Nie można pobrać listy zabiegów.");
            });
      }
    },
    getAllTypyWizyt() {
      therapistsService.GetWszystkieTypyWizyt().then(result => {
        this.typywizyt = result.data.result
      }).catch(() => {
        this.error("Nie można pobrać typów wizyt terapeutów.");
      })
    },
    getFormattedDate(val)
    {
      let dj = dayjs(val)
      if(dj != null)
      {
        return dj.format("DD-MM-YYYY")
      }
      else
      {
        return val
      }
    },
    getFormattedTime(item)
    {
      let dj = dayjs(item.startTime)
      let dj2 = dayjs(item.endTime)
      if(dj != null && dj2 != null)
      {
        return dj.format('HH:mm')+ ' - '+dj2.format('HH:mm')
      }
      return ''
    },
    getStatusDescription(status)
    {
      switch(status)
      {
        case 0:
          return 'Nowa'
        case 1:
          return 'Potwierdzona'
        case 2:
          return 'Anulowana'
        case 3:
          return 'Zakończona'
        case 5:
          return 'Do wyjaśnienia'
        default:
          return ''
      }
    },
    loadVisits() {
      this.overlay = true
      visitService.getSMSVisits().then(result=> {
        this.visits = result.data.result
        this.overlay = false
      }).catch(() => {
        this.showError('Błąd pobierania stanu wizyt SMS')
      })
    },
    showError( text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    },
  },
  computed: {
    ...mapState('featuresModule',['features']),
    isFizykoTerapiaEnabled: function() {
      return this.features && this.features.Fizykoterapia
    },
    filtered_visits: function() {

      if(this.typ_filtra != null && this.typ_filtra == 1)
        return this.visits.filter(x=> x.wyslanoSMS == false)
      if(this.typ_filtra != null && this.typ_filtra == 2)
        return this.visits.filter(x=> x.status == 5)

      return this.visits
    },
    showModal: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        if (!value) {
          this.$emit('close')
        }

      }
    },
  }
}
</script>

<style scoped>

</style>